import { Form, Spin } from "antd";
import Title from "../../component/PageTitle";
import { PiHouseLine } from "react-icons/pi";
import IncomeForm from "../../component/Form/IncomeForm";
import {
    useAddIncomeTypeMutation,
    useAddIncomeMutation,
    useEditIncomeMutation,
    useAddPaymentMethodMutation
} from "../../slices/apiSlice";
import { toast } from "react-toastify";
import {
    useGetAllPaymentDataQuery,
    useGetPropertiesQuery,
    useGetLabelsQuery,
    useGetPaymentMethodsQuery,
    useGetIncomeNameQuery,
    useGetIncomeDetailsByIdQuery
} from "../../slices/getSlice";
import { useEffect, useState } from "react";
import { SlCalender } from "react-icons/sl";
import { useLocation, useNavigate, useOutletContext } from "react-router-dom";
import TopHeader from "../../component/Header";
import { HomeOutlined } from '@ant-design/icons';
import { Breadcrumb } from 'antd';
import {
    RiStickyNoteLine,
} from "react-icons/ri";
import { MdOutlinePayment } from "react-icons/md";
import { FaHandHoldingDollar, FaRegCalendarCheck } from "react-icons/fa6";
import { GiMoneyStack } from "react-icons/gi";
import dayjs from "dayjs";
import { useSelector } from "react-redux";

const AddIncome = () => {
    const [form] = Form.useForm();
    const [labelForm] = Form.useForm();
    const { loading, setLoading } = useOutletContext();
    const navigate = useNavigate();
    const location = useLocation();
    const [property, setProperty] = useState();
    const [category, setCategory] = useState();
    const [paymentMethods, setPaymentMethods] = useState([]);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [newDropdownOpen, setNewDropdownOpen] = useState(false);
    const [incomeDropdownOpen, setIncomeNameDropdown] = useState(false);
    const [newlyAddedIncome, setNewlyAddedIncome] = useState(null);
    const [IncomeNameDataList, setIncomeNameDataList] = useState([]);
    const [newlyAddedPaymentMethod, setNewlyAddedPaymentMethod] = useState(null);
    const colorData = useSelector((state) => state.persistedReducer?.colors);
    let IncomeID = location?.state?.id;
    let propertyData = location?.state?.propertyData;
    const [isSaving, setIsSaving] = useState(false);

    const {
        data: getProperties,
        refetch: refetchProperties,
    } = useGetPropertiesQuery();

    useEffect(() => {
        refetchProperties();
    }, [getProperties]);

    const {
        data: IncomeApiData,
        isLoading: loadingIncomeData,
        refetch: refetchIncomeApiData,
        isError: incomeApiError,
        error: incomeApiErrorDetails,
    } = useGetIncomeDetailsByIdQuery(IncomeID, {
        skip: !IncomeID,
        refetchOnMountOrArgChange: true,
        refetchOnFocus: true,
        refetchOnReconnect: true,
    });

    const { data: labelData, refetch: refetchLabels } = useGetLabelsQuery('income_form');
    const { data: paymentMethodData, refetch: refetchPaymentMethods } = useGetPaymentMethodsQuery();
    const { data: incomeNameData, refetch: refetchIncomeName } = useGetIncomeNameQuery();
    const { data: getCategory, refetch: refetchCategory } = useGetAllPaymentDataQuery('income');
    const [addIncome, { isLoading: isLoadingAddincome }] = useAddIncomeMutation();
    const [editIncome, { isLoading: isLoadingEditincome }] = useEditIncomeMutation();
    const [addPaymentMethod, { isLoading: paymentTypeLoading }] = useAddPaymentMethodMutation();
    const [addIncomeType, { isLoading: incomeTypeLoading }] = useAddIncomeTypeMutation();
    const [IncomeData, setIncomeData] = useState(null);

    useEffect(() => {
        if (IncomeID !== undefined && IncomeID !== null) {
            refetchIncomeApiData();
        }
    }, [IncomeApiData]);

    useEffect(() => {
        return () => {
            setIncomeData(null);
        };
    }, []);


    useEffect(() => {
        if (IncomeApiData) {
            if (IncomeApiData.data && IncomeApiData.data !== "Income not found") {
                setIncomeData(IncomeApiData.data);
            }
        }
    }, [IncomeApiData]);

    useEffect(() => {
        if (incomeApiError) {
            setIncomeData(null);
            form.resetFields();
            if (IncomeID) {
                navigate('/income');
            }
        } else if (IncomeApiData) {
            form.setFieldsValue({
                'category_id': IncomeApiData?.payment_type?.id,
                'amount': IncomeApiData?.amount,
                'property_id': IncomeApiData?.property?.id,
                'notes': IncomeApiData?.notes,
                'start_date': IncomeApiData?.start_date ? dayjs(IncomeApiData.start_date) : null,
            });
        }
    }, [IncomeApiData, incomeApiError, incomeApiErrorDetails, form, navigate]);

    const capitalizeFirstLetter = (string) => {
        return string?.charAt(0)?.toUpperCase() + string?.slice(1);
    };

    useEffect(() => {
        labelForm.setFieldsValue(labelData)
    }, [labelData]);

    useEffect(() => {
        if (paymentMethodData) {
            const transformedOptions = paymentMethodData?.data.map((item) => ({
                label: item.payment_mode,
                value: item.id,
            }));
            setPaymentMethods(transformedOptions);
        }

    }, [paymentMethodData]);

    const FrequencyOptions = [
        { label: "Daily", value: "daily" },
        { label: "Weekly", value: "weekly" },
        { label: "Bi-Weekly", value: "biweekly" },
        { label: "Monthly", value: "monthly" },
        { label: "Yearly", value: "yearly" },
    ];

    const field = [
        {
            component: "select",
            label: capitalizeFirstLetter(labelData?.Property) || "Property",
            name: "property_id",
            placeholder: "Please select property",
            suffixIcon: (
                <PiHouseLine style={{ color: "#F47939", fontSize: "25px" }} />
            ),
            rules: [
                {
                    required: true,
                    message: "Please select property ",
                },
            ],
            options: property,
            colSpan: 12,
        },
        {
            component: "select",
            label: capitalizeFirstLetter(labelData?.type_of_income) || "Type of income",
            name: "category_id",
            placeholder: "Select Income type",
            suffixIcon: (
                <FaHandHoldingDollar style={{ color: "#F47939", fontSize: "25px" }} />
            ),
            rules: [
                {
                    required: true,
                    message: "Please select type of income",
                },
            ],
            options: category,
            colSpan: 12,
        },
        {
            component: "select",
            label: capitalizeFirstLetter(labelData?.payment_method) || "Income Type",
            name: "payment_mode_id",
            placeholder: "Select Income Type or start typing to create new",
            suffixIcon: (
                <MdOutlinePayment style={{ color: "#F47939", fontSize: "25px" }} />
            ),
            rules: [
                {
                    required: true,
                    message: "Please select income type.",
                },
            ],
            options: paymentMethods,
            colSpan: 12,
            max: 40
        },
        {
            component: "input",
            type: "number",
            label: capitalizeFirstLetter(labelData?.amount) || "Amount",
            name: "amount",
            placeholder: "Enter Amount",
            prefix: (
                <GiMoneyStack
                    style={{ color: "#F47939", fontSize: "25px" }}
                />
            ),

            onKeyDown: (e) => {

                if (['e', 'E', '+', '-'].includes(e.key)) {
                    e.preventDefault();
                }
            },

            onPaste: (e) => {
                e.preventDefault();
            },

            onCut: (e) => {
                e.preventDefault();
            },

            onContextMenu: (e) => {
                e.preventDefault();
            },
            // Prevent drag and drop
            onDrop: (e) => {
                e.preventDefault();
            },
            rules: [
                {
                    required: true,
                    message: "Please enter amount.",
                },
                {
                    pattern: /^(0|[1-9]\d*)(\.\d+)?$/,
                    message: 'Amount must be a positive number',
                },
            ],
            colSpan: 12,
        },
        {
            component: "input",
            type: "date",
            label: "Income Date",
            name: "start_date",
            placeholder: "Select income date",
            prefix: (
                <SlCalender
                    style={{ color: "#F47939", fontSize: "25px", height: "20px" }}
                />
            ),
            rules: [
                {
                    required: true,
                    message: "Please input your income date",
                },
            ],
            colSpan: 12,
        },
        // {
        //     component: "input",
        //     type: "date",
        //     label: capitalizeFirstLetter(labelData?.end_date) || "Next Payment Date",
        //     name: "end_date",
        //     placeholder: "Select next payment date ",
        //     prefix: (
        //         <SlCalender
        //             style={{ color: "#F47939", fontSize: "25px", height: "20px" }}
        //         />
        //     ),
        //     rules: [
        //         {
        //             required: true,
        //             message: "Please input your end date",
        //         },
        //     ],
        //     colSpan: 12,
        // },
        {
            component: "select",
            label: capitalizeFirstLetter(labelData?.frequency) || "Frequency",
            name: "frequency",
            placeholder: "Select Frequency",
            suffixIcon: (
                <FaRegCalendarCheck style={{ color: "#F47939", fontSize: "25px" }} />
            ),
            rules: [
                {
                    required: true,
                    message: "Please select frequency of income",
                },
            ],
            options: FrequencyOptions,
            colSpan: 12,
        },
        {
            component: "input",
            type: "text",
            label: capitalizeFirstLetter(labelData?.notes) || "Income Name",
            name: "notes",
            placeholder: "Select income name or start typing to create new",
            prefix: (
                <RiStickyNoteLine
                    style={{ color: "#F47939", fontSize: "25px", height: "20px" }}
                />
            ),
            rules: [
                {
                    required: true,
                    message: "Please select income name.",
                },
            ],
            colSpan: 12,
            max: 40
        },
    ];

    useEffect(() => {
        if (getProperties && getProperties.data) {
            const transformedOptions = getProperties.data.map((item) => ({
                label: item.name_of_property,
                value: item.id,
            }));
            setLoading(false)
            setProperty(transformedOptions);
        }
        if (getCategory && getCategory.data) {
            const transformedOptions = getCategory.data.map((item) => ({
                label: item.name,
                value: item.id,
            }));
            setCategory(transformedOptions);
        }

    }, [getProperties, getCategory]);

    useEffect(() => {
        refetchIncomeName();
    }, []);

    useEffect(() => {
        const style = document.createElement("style");
        style.innerHTML = `
        .ant-select .ant-select-selector {
          border-color: ${colorData?.primary || '#F47A3A'} !important;
        }
          .ant-form-item-control-input-content .ant-input-number-affix-wrapper  {
               border-color: ${colorData?.primary || '#F47A3A'} !important;
          }
                  .ant-picker   {
               border-color: ${colorData?.primary || '#F47A3A'} !important;
          }
               .ant-select-arrow svg{
                color: ${colorData?.primary || '#F47A3A'} !important;
               }
                .ant-input-number-affix-wrapper svg {
                     color: ${colorData?.primary || '#F47A3A'} !important;
                }
                     .ant-picker svg {
                      color: ${colorData?.primary || '#F47A3A'} !important;
                     }
      `;
        document.head.appendChild(style);

        return () => {
            document.head.removeChild(style);
        };
    }, [colorData]);

    useEffect(() => {
        if (incomeNameData) {
            setIncomeNameDataList(incomeNameData?.data);
        }
    }, [incomeNameData]);

    const onFinish = async (values) => {
        setIsSaving(true);

        try {
            const value = {
                property_id: values?.property_id
                    ? values?.property_id
                    : location?.state?.propertyId,

                category_id: values?.category_id
                    ? values?.category_id
                    : location?.state?.categoryId,
                amount: values?.amount
                    ? values?.amount
                    : location?.state?.amount,
                start_date: values?.start_date
                    ? values?.start_date
                    : location?.state?.start_date,
                // end_date: values?.end_date ? values?.end_date : location?.state?.end_date,
                frequency: values?.frequency ? values?.frequency : location?.state?.frequency ? location?.state?.frequency : null,
                notes: values?.notes ? values?.notes : location?.state?.notes ? location?.state?.notes : null,
                payment_mode_id: values?.payment_mode_id ? values?.payment_mode_id : location?.state?.payment_mode_id ? location?.state?.payment_mode_id : null
            };

            if (value.end_date !== null) {
                if (value.start_date > value.end_date) {
                    toast.error("Start date should be less than end date");
                    return false;
                }
            }

            if (value?.category_id !== 19 && value?.category_id !== 2) {
                value.end_date = null;
                value.frequency = null;
            }

            if (IncomeID) {
                if (typeof value.category_id == "string") {
                    let categoryData = category.find(
                        (cat) => cat.label == value.category_id
                    );
                    value.category_id = categoryData.value;
                }
                if (typeof value.property_id == "string") {
                    let proData = property.find((pro) => pro.label == value.property_id);
                    value.property_id = proData.value;
                }

                const response = await editIncome({ data: value, IncomeID });

                if (response.data) {
                    toast.success("Income updated!");
                    form.resetFields();
                    const params = new URLSearchParams(location.search);
                    const type = params.get('type');
                    if (type !== 'income') {
                        navigate("/view_property", {
                            state: { propertyData: propertyData },
                        });
                    } else {
                        navigate("/income");
                    }
                } else {
                    toast.error(`${response?.error?.data?.message}`);
                }
            } else {
                const response = await addIncome(values);
                if (response.data) {
                    toast.success("Income added!");
                    form.resetFields();
                    const params = new URLSearchParams(location.search);
                    const type = params.get('type');
                    if (type !== 'income') {
                        navigate("/view_property", {
                            state: { propertyData: propertyData },
                        });
                    } else {
                        navigate("/income");
                    }
                } else {
                    toast.error(`${response?.data?.message}`);
                }
            }
        } catch {
        } finally {
            setIsSaving(false)
        }
    };

    const addNewIncome = async (value) => {
        setIsSaving(true)
        const formData = {
            category_of: 'income',
            name: value
        }
        try {
            const response = await addIncomeType(formData);
            if (response.data) {
                toast.success("Income Type has been created successfully");
                let newList = await refetchCategory();
                const transformedOptions = newList.data.data.map((item) => ({
                    label: item.name,
                    value: item.id,
                }));
                setCategory(transformedOptions);
                let newIncome = transformedOptions?.find((item) => item?.label === value);
                setNewlyAddedIncome(newIncome?.value);
                setDropdownOpen(false);
            } else {
                toast.error(`${response?.error?.data?.message}`);
            }
        } catch (error) {

        } finally {
            setIsSaving(false)
        }
    }

    const handleAddPaymentType = async (value) => {
        setIsSaving(true);
        const formData = {
            payment_mode: value,
        }
        try {
            const response = await addPaymentMethod(formData);
            if (response.data) {
                toast.success("Income Type added successfully!");
                let newList = await refetchPaymentMethods();
                const transformedOptions = newList.data.data.map((item) => ({
                    label: item.payment_mode,
                    value: item.id,
                }));
                setPaymentMethods(transformedOptions);
                let newPayment = transformedOptions?.find((item) => item?.label === value);
                setNewlyAddedPaymentMethod(newPayment?.value);
                setNewDropdownOpen(false);
            } else {
                toast.error(`${response?.error?.data?.message}`);
            }
        } catch (error) {

        } finally {
            setIsSaving(false)
        }
    }

    const fetchLastParent = () => {
        let getParent = JSON.parse(localStorage?.getItem('lastOpenMenu'));
        let child = getParent?.child;

        if (child === "income") {
            return "Income";
        }

        return child ? child.charAt(0).toUpperCase() + child.slice(1) : "";
    };

    return (
        <>
            {loading || loadingIncomeData && (
                <div className="commanLoaderWrapper">
                    <Spin size="large" />
                    <h4>Setting things up..</h4>
                </div>
            )}
            <TopHeader
                title={
                    IncomeID ? (
                        <Title title="Edit Income" />
                    ) : (
                        <Title title="Add Income" />
                    )
                }
            />
            <div className="customPadding">
                <div className="breadcrumbWrapper">
                    <Breadcrumb
                        items={[
                            {
                                title: (
                                    <span onClick={() => navigate('/dashboard')} style={{ cursor: 'pointer' }}>
                                        <HomeOutlined />
                                    </span>
                                ),
                            },
                            {
                                title: (
                                    <>
                                        <span>{fetchLastParent()}</span>
                                    </>
                                ),
                            },
                            {
                                title: (
                                    <>
                                        <span>{IncomeID ? 'Edit' : 'Add'} Income</span>
                                    </>
                                ),
                            },
                        ]}
                    />
                </div>
                <div className="mainWrapper">
                    <div className="card tableCard">
                        <div className="card-body">
                            <IncomeForm
                                form={form}
                                fields={field}
                                onFinish={onFinish}
                                buttonName={location?.state?.id ? "Save" : "Add"}
                                FormInitialValues={IncomeData}
                                ButtonDisable={isSaving}
                                loading={location?.state?.id ? isLoadingEditincome : isLoadingAddincome}
                                addNewIncome={addNewIncome}
                                dropdownOpen={dropdownOpen}
                                setDropdownOpen={setDropdownOpen}
                                newlyAddedIncome={newlyAddedIncome}
                                incomeTypeLoading={incomeTypeLoading}
                                handleAddPaymentType={handleAddPaymentType}
                                paymentTypeLoading={paymentTypeLoading}
                                newlyAddedPaymentMethod={newlyAddedPaymentMethod}
                                newDropdownOpen={newDropdownOpen}
                                setNewDropdownOpen={setNewDropdownOpen}
                                IncomeNameDataList={IncomeNameDataList}
                                incomeDropdownOpen={incomeDropdownOpen}
                                setIncomeNameDropdown={setIncomeNameDropdown}
                                loadingIncomeData={loadingIncomeData}
                                propertyData={propertyData}
                            />
                        </div>
                    </div>

                </div>
            </div>
        </>
    );
};

export default AddIncome;
